export const VARIANT_SEPARATOR = "___";

export const APP_NAME = {
    BLUE_GREEN: "blueGreen",
    SYNC_SYSTEM: "sync",
    CORE: "core",
    ADMIN: "admin",
    API: "api"
};
